/* Subscription Builder (Main + Gift) */

// Load Subscription Builder login on page load
document.addEventListener('DOMContentLoaded', initSubscriptions);

function initSubscriptions() {
  // Helper functions
  const qs  = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => Array.from(c.querySelectorAll(s));

  // Load variant matrix once
  let variantMatrix = {};
  const variantDataEl = qs('#variant-data');
  if (variantDataEl) {
    try { variantMatrix = JSON.parse(variantDataEl.textContent.trim()); }
    catch (e) { console.error('Failed to parse #variant-data JSON', e); }
  }

  const SMARTRR_MAIN_PLANS = {
    'week:1':  '3512402056',
    'weeks:2': '3512434824',
    'weeks:3': '3512467592',
    'weeks:4': '3512500360',
  };

  const SMARTRR_GIFT_PLANS = {
    '3 Month':  '3822747784',
    '6 Month':  '3822780552',
    '12 Month': '3822813320',
  };

  const scrollToEl = (el) => el && window.scrollTo({ top: el.offsetTop - 200, behavior: 'smooth' });

  const markSelected = (list, item) => {
    list.forEach(li => {
      const is = li === item;
      li.classList.toggle('selected', is);
      const btn = qs('.subscription-btn', li);
      if (btn) btn.textContent = is ? 'Selected' : 'Select';
    });
  };

  const getQtyFromLi = (li) => {
    const input = qs('.quantity__input', li) || qs('input[name="quantity"]', li);
    const v = input ? parseInt(input.value || '1', 10) : 1;
    return Number.isNaN(v) ? 1 : Math.max(1, v);
  };

  const wireQtyControls = (li, onChange) => {
    const inputs  = qsa('.quantity__input, input[name="quantity"]', li);
    const buttons = qsa('.quantity__button', li);
    const stop = (e) => e.stopPropagation();
    [...inputs, ...buttons].forEach(el => {
      el.addEventListener('click', stop);
      el.addEventListener('mousedown', stop);
      el.addEventListener('touchstart', stop, { passive: true });
    });

    inputs.forEach(input => {
      ['input','change','keyup'].forEach(evt => input.addEventListener(evt, onChange));
    });
    buttons.forEach(btn => btn.addEventListener('click', () => setTimeout(onChange, 0)));
  };

  const addToCart = (data) =>
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(data).toString(),
    }).then(r => r.json());

  // Reset Function
  const resetAllFlows = () => {
    // Hide all wrappers
    qsa(`
      .blend-wrapper,
      .size-wrapper,
      .size-wrapper.gift-size,
      .grind-type-wrapper,
      .frequency-wrapper,
      .summary-wrapper,
      .summary-wrapper.gift-summary
    `).forEach(el => el.style.display = 'none');

    // Hide all size lists (default + single-origin)
    qsa('.size-wrapper .sizes').forEach(ul => ul.style.display = 'none');

    // Clear selected & button text
    qsa('li.selected').forEach(li => li.classList.remove('selected'));
    qsa('.subscription-btn').forEach(b => (b.textContent = 'Select'));

    // Reset quantities
    qsa('.quantity__input, input[name="quantity"]').forEach(i => (i.value = '1'));

    // Clear all summary and price content
    qsa(".summary-item .summary-item__name span, .order-item__price, .order-item__desc")
      .forEach(el => {
        const row = el.closest(".order-item");
        // Only clear Coffee/Total rows — skip Shipping
        if (row && row.classList.contains("shipping")) return;
        el.textContent = "";
      });

    // Clear button data attributes
    qsa('.subscribe-btn').forEach(btn => {
      ['variant','variantTitle','subscription','sellingPlan'].forEach(k => delete btn.dataset[k]);
    });

    // Clear active title references
    qsa('.coffee-wrapper').forEach(c => (c.dataset.activeTitle = ''));

    // Re-show first step wrappers
    qsa('.coffee-wrapper, .gift-wrapper').forEach(el => el.style.display = 'block');

    // Scroll to top
    scrollToEl(document.querySelector('.coffee-wrapper'));
  };

  // Gift Subscription Flow
  const initGift = (root) => {
    const giftWrapper = qs('.gift-wrapper', root);
    const giftSizeWrapper = qs('.size-wrapper.gift-size', root);
    const giftSummary = qs('.summary-wrapper.gift-summary', root);
    const subBtn = qs('.subscribe-btn', root);
    const restartBtn = qs('.restart-btn', root);
    if (!giftWrapper || !giftSummary || !subBtn) return;

    const FIXED_GIFT_VARIANT = '43145761128584';
    const ui = {
      durationSpan: qs('.summary-item.summary-duration span', root),
      qtySpan: qs('.summary-item.summary-quantity span', root),
      priceSpan: qs('.summary-price .order-item__price', root),
      totalSpan: qs('.order-item--total .order-item__price', root),
    };

    const giftSizeItem = qs('.size-wrapper.gift-size .size-item', root);
    if (giftSizeItem) {
      markSelected([giftSizeItem], giftSizeItem);
      wireQtyControls(giftSizeItem, () => {
        const qty = getQtyFromLi(giftSizeItem);
        if (giftSummary.style.display !== 'none' && ui.qtySpan)
          ui.qtySpan.textContent = `250G × ${qty}`;
      });
    }

    const updateGiftSummary = ({ title, prepaid }) => {
      const qty = giftSizeItem ? getQtyFromLi(giftSizeItem) : 1;
      if (ui.durationSpan) ui.durationSpan.textContent = `${title} Gift Subscription`;
      if (ui.qtySpan) ui.qtySpan.textContent = `250G × ${qty}`;
      if (ui.priceSpan) ui.priceSpan.textContent = `$${Number(prepaid).toFixed(2)}`;
      if (ui.totalSpan) ui.totalSpan.textContent = `$${Number(prepaid).toFixed(2)}`;
    };

    // Change links
    qsa('.summary-item .summary-item__btn', root).forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const li = btn.closest('.summary-item');
        if (li?.classList.contains('summary-duration')) scrollToEl(giftWrapper);
        if (li?.classList.contains('summary-quantity')) scrollToEl(giftSizeWrapper || giftWrapper);
      });
    });

    // Duration selection
    qsa('.gift-wrapper .gift-item', root).forEach(item => {
      const title = item.dataset.title || '';
      item.dataset.sellingPlan = SMARTRR_GIFT_PLANS[title] || '';
      item.addEventListener('click', () => {
        markSelected(qsa('.gift-wrapper .gift-item', root), item);
        const prepaid = parseFloat(item.dataset.prepaidPrice || '0') || 0;
        subBtn.dataset.variant = FIXED_GIFT_VARIANT;
        subBtn.dataset.sellingPlan = item.dataset.sellingPlan;
        subBtn.dataset.title = title;
        subBtn.dataset.prepaid = String(prepaid);
        updateGiftSummary({ title, prepaid });
        giftSummary.style.display = 'flex';
        scrollToEl(giftSummary);
      });
    });

    subBtn.addEventListener('click', () => {
      const variant = subBtn.dataset.variant;
      const plan = subBtn.dataset.sellingPlan;
      const qty = giftSizeItem ? getQtyFromLi(giftSizeItem) : 1;
      if (!variant || !plan) return alert('Please select a duration.');
      addToCart({ id: variant, quantity: qty, selling_plan: plan })
        .then(() => (window.location.href = '/cart'))
        .catch(err => console.error('Gift add-to-cart failed', err));
    });

    restartBtn?.addEventListener('click', e => { e.preventDefault(); resetAllFlows(); });
  };

  // Main Subscription Flow
  const initMain = (root) => {
    const coffeeWrapper = qs('.coffee-wrapper', root);
    const blendWrapper = qs('.blend-wrapper', root);
    const sizeWrapper = qs('.size-wrapper:not(.gift-size)', root);
    const grindWrapper = qs('.grind-type-wrapper', root);
    const frequencyWrapper = qs('.frequency-wrapper', root);
    const summaryWrapper = qs('.summary-wrapper:not(.gift-summary)', root);
    const subBtn = qs('.subscribe-btn', root);
    const restartBtn = qs('.restart-btn', root);
    if (!coffeeWrapper || !sizeWrapper || !grindWrapper || !frequencyWrapper || !summaryWrapper || !subBtn) return;

    const ui = {
      sCoffee: qs('.summary-item.coffee .summary-item__name span', root),
      sQty: qs('.summary-item.summary-quantity .summary-item__name span', root),
      sGrind: qs('.summary-item.grind-type .summary-item__name span', root),
      sFreq: qs('.summary-item.frequency .summary-item__name span', root),
      sPrice: qs('.summary-price .order-item__price', root),
      sTotal: qs('.order-item--total .order-item__price', root),
    };

    const getSelected = (scope) => qs('li.selected', scope);

    const updateSummary = () => {
      const coffeeSel = getSelected(coffeeWrapper) || getSelected(blendWrapper);
      const sizeSel = getSelected(sizeWrapper);
      const grindSel = getSelected(grindWrapper);
      const freqSel = getSelected(frequencyWrapper);
      const activeTitle = coffeeSel?.dataset.title || coffeeWrapper.dataset.activeTitle || '';

      if (ui.sCoffee && activeTitle) ui.sCoffee.textContent = activeTitle;
      if (ui.sGrind && grindSel) ui.sGrind.textContent = grindSel.dataset.grindType || '';
      if (ui.sFreq && freqSel) ui.sFreq.textContent = qs('h2', freqSel)?.textContent?.trim() || '';
      if (ui.sQty && sizeSel)
        ui.sQty.textContent = `${sizeSel.dataset.title} × ${getQtyFromLi(sizeSel)}`;

      const variants = variantMatrix[activeTitle];
      const sizeLabel = sizeSel?.dataset.title;
      const grindKey = (grindSel?.dataset.grindType || '').toLowerCase().replace(' grind', '').trim();

      if (variants && sizeLabel) {
        const match =
          variants.find(v => {
            const t = v.title.toLowerCase();
            return t.includes(sizeLabel.toLowerCase()) && (!grindKey || t.includes(grindKey));
          }) || variants.find(v => v.title.toLowerCase().includes(sizeLabel.toLowerCase()));

        if (match) {
          const unit = (match.price || 0) / 100;
          const qty = getQtyFromLi(sizeSel);
          const total = unit * qty;
          subBtn.dataset.variant = match.id;
          subBtn.dataset.variantTitle = match.title;
          if (ui.sPrice) ui.sPrice.textContent = `$${unit.toFixed(2)}`;
          if (ui.sTotal) ui.sTotal.textContent = `$${total.toFixed(2)}`;
        }
      }
    };

    // Coffee selection
    const coffeeItems = qsa('.coffee-item', root);
    coffeeItems.forEach(item => {
      const btn = item.querySelector('.subscription-btn');
      if (btn) btn.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); item.click(); });

      item.addEventListener('click', () => {
        markSelected(coffeeItems, item);

        subBtn.dataset.subscription = item.dataset.subscription || '';

        // Hide later steps until size is chosen
        grindWrapper.style.display = 'none';
        frequencyWrapper.style.display = 'none';
        summaryWrapper.style.display = 'none';

        if (item.classList.contains('blends')) {
          blendWrapper.style.display = 'block';
          sizeWrapper.style.display = 'none';
          scrollToEl(blendWrapper);
        } else {
          blendWrapper.style.display = 'none';
          sizeWrapper.style.display = 'block';
          const isSingle = item.classList.contains('single-origin-subscription');
          const defaultSizes = qs('.sizes.default-sizes', sizeWrapper.parentElement);
          const singleSizes = qs('.sizes.single-origin-subscription', sizeWrapper.parentElement);
          if (defaultSizes && singleSizes) {
            defaultSizes.style.display = isSingle ? 'none' : 'flex';
            singleSizes.style.display = isSingle ? 'flex' : 'none';
          }
          coffeeWrapper.dataset.activeTitle = item.dataset.title || '';
          scrollToEl(sizeWrapper);
          wireSizeClicks();
        }
        updateSummary();
      });
    });

    // Blend step
    const blendItems = qsa('.blend-wrapper .coffee-item', root);
    blendItems.forEach(item => {
      const btn = item.querySelector('.subscription-btn');
      if (btn) btn.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); item.click(); });

      item.addEventListener('click', () => {
        markSelected(blendItems, item);
        const title = item.dataset.title || '';
        coffeeWrapper.dataset.activeTitle = title;
        subBtn.dataset.subscription = item.dataset.subscription || '';
        if (ui.sCoffee) ui.sCoffee.textContent = title;
        const defaultSizes = qs('.sizes.default-sizes', sizeWrapper.parentElement);
        const singleSizes = qs('.sizes.single-origin-subscription', sizeWrapper.parentElement);
        if (defaultSizes && singleSizes) {
          defaultSizes.style.display = 'flex';
          singleSizes.style.display = 'none';
        }
        sizeWrapper.style.display = 'block';
        grindWrapper.style.display = 'none';
        frequencyWrapper.style.display = 'none';
        summaryWrapper.style.display = 'none';
        scrollToEl(sizeWrapper);
        wireSizeClicks();
        updateSummary();
      });
    });

    // Size step
    const wireSizeClicks = () => {
      const sizeItems = qsa('.size-item', sizeWrapper);
      sizeItems.forEach(li => {
        wireQtyControls(li, updateSummary);
        
        const btn = li.querySelector('.subscription-btn');
        if (btn) btn.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); li.click(); });
        
        li.addEventListener('click', e => {
          if (e.target.closest('.quantity__input, .quantity__button, input[name="quantity"]')) return;
          markSelected(sizeItems, li);
          grindWrapper.style.display = 'block';
          scrollToEl(grindWrapper);
          updateSummary();
        });
      });
    };
    wireSizeClicks();

    // Grind step
    const grindItems = qsa('.grind-type-wrapper li', root);
    grindItems.forEach(item => {
      const btn = item.querySelector('.subscription-btn');
      if (btn) btn.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); item.click(); });
      
      item.addEventListener('click', () => {
        markSelected(grindItems, item);
        frequencyWrapper.style.display = 'block';
        scrollToEl(frequencyWrapper);
        updateSummary();
      });
    });

    // Frequency step
    const frequencyItems = qsa('.frequency-wrapper li', root);
    frequencyItems.forEach(item => {
      const interval = (item.dataset.interval || '').toLowerCase();
      const freq = (item.dataset.frequency || '').toLowerCase();
      const key = `${interval}:${freq}`;
      if (SMARTRR_MAIN_PLANS[key]) item.dataset.sellingPlan = SMARTRR_MAIN_PLANS[key];
      
      const btn = item.querySelector('.subscription-btn');
      if (btn) btn.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); item.click(); });
      
      item.addEventListener('click', () => {
        markSelected(frequencyItems, item);
        summaryWrapper.style.display = 'flex';
        scrollToEl(summaryWrapper);
        updateSummary();
      });
    });

    // Subscribe button
    subBtn.addEventListener('click', () => {
      const variantId = subBtn.dataset.variant;
      const sizeSel = qs('.size-item.selected', sizeWrapper);
      const freqSel = qs('.frequency-wrapper li.selected', root);
      const qty = sizeSel ? getQtyFromLi(sizeSel) : 1;
      const planId = freqSel?.dataset.sellingPlan || '';
      if (!variantId || !planId) return alert('Please complete your selections first.');
      
      addToCart({ id: variantId, quantity: qty, selling_plan: planId })
        .then(() => (window.location.href = '/cart'))
        .catch(err => console.error('Main add-to-cart failed', err));
    });

    // Change links
    qsa('.summary-item .summary-item__btn', root).forEach(btn => {
      btn.addEventListener('click', () => {
        const li = btn.closest('.summary-item');
        if (!li) return;
        if (li.classList.contains('coffee')) scrollToEl(coffeeWrapper);
        if (li.classList.contains('summary-quantity')) scrollToEl(sizeWrapper);
        if (li.classList.contains('grind-type')) scrollToEl(grindWrapper);
        if (li.classList.contains('frequency')) scrollToEl(frequencyWrapper);
      });
    });

    restartBtn?.addEventListener('click', e => { e.preventDefault(); resetAllFlows(); });
  };


  // Initialize both wrappers safely
  qsa('.subscription-wrapper').forEach(root => {
    const hasGift = !!qs('.gift-wrapper', root);
    const hasMain = !!qs('.coffee-wrapper', root) && !!qs('.summary-wrapper:not(.gift-summary)', root);

    if (hasGift) {
      initGift(root);
    } else if (hasMain) {
      initMain(root);
    } else {
      console.warn('⚠️ No matching flow found in this .subscription-wrapper');
    }
  });
};
